import {AsyncPipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {CopyTooltipModule} from '../../components/copy-tooltip/copy-tooltip.module';
import {
    DeliverableAutocompleteModule
} from '../../components/deliverable-input/deliverable-autocomplete/deliverable-autocomplete.module';
import {DeliverableInputComponent} from '../../components/deliverable-input/deliverable-input.component';
import {DexWalletInputComponent} from '../../components/dex-wallet-input/dex-wallet-input.component';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {ShortenWalletAddrPipe} from '../../components/dynamic-xyz/utils/shorten-wallet-addr.pipe';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {TooltipModule} from '../../components/tooltip';
import {L10nModule} from '../../components/translate';
import {DecimalInputModule} from '../../directives/decimal-input';
import {DelMinQtyPipe} from '../dex-lp-trade-widget/del-min-qty.pipe';
import {DEX_TRANSFER_WIDGET_DESCRIPTION} from './dex-transfer-widget-description';
import {DexTransferWidgetComponent} from './dex-transfer-widget.component';
import {DexTransferWidgetSettingsService} from './settings/dex-transfer-widget-settings.service';

@NgModule({
    imports: [
        ReactiveFormsModule,
        L10nModule,
        DecimalInputModule,
        DeliverableAutocompleteModule,
        DeliverableInputComponent,
        DelMinQtyPipe,
        DexWalletInputComponent,
        ShortenWalletAddrPipe,
        CopyTooltipModule,
        TooltipModule,
        AsyncPipe,
        BigintDeliverableDisplayDecimalPipe,
        DisplayDecimalModule
    ],
    declarations: [
        DexTransferWidgetComponent
    ],
    exports:         [
        DexTransferWidgetComponent
    ],
    providers:       [
        DexTransferWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_TRANSFER_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexTransferWidgetModule {}
